import { TabIconProps } from '../../interfaces/icons'

const Edit = ({ active = false }: TabIconProps) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2214_2334)">
        <path
          d="M17.932 5.14873C18.7479 4.33282 20.0707 4.33282 20.8866 5.14873V5.14873C21.7026 5.96465 21.7026 7.28751 20.8866 8.10343L9.06787 19.9222H6.11317V16.9675L17.932 5.14873Z"
          stroke={active ? 'white' : 'black'}
          stroke-width="1.56696"
        />
        <path
          d="M16.4547 6.62646L19.4094 9.58116"
          stroke={active ? 'white' : 'black'}
          stroke-width="1.56696"
        />
      </g>
      <defs>
        <clipPath id="clip0_2214_2334">
          <rect width="24" height="24" fill="white" transform="translate(0.964233)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Edit
